function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 7.01C0 9.16 0.53 11.45 1.06 14.98C1.48 17.74 2.49 20.03 4.26 20.03C6.02 20.03 7.2 18.5 7.2 15.71C7.2 14.76 6.42 13.25 6.39 11.95C6.32 9.62 7.95 8.69 7.95 6.54C7.95 2.67 6.61 0 4.26 0C1.91 0 0 3.14 0 7.01ZM12.05 14.55C12.05 16.71 13.68 17.64 13.61 19.97C13.58 21.26 12.8 22.77 12.8 23.72C12.8 26.51 13.98 28.04 15.74 28.04C17.51 28.04 18.52 25.75 18.94 22.99C19.47 19.46 20 17.18 20 15.02C20 11.15 18.09 8.01 15.74 8.01C13.39 8.01 12.05 10.68 12.05 14.55Z",
  id: "c36r6dNCaw"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c36r6dNCaw",
  opacity: 1,
  fill: "#000000",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c36r6dNCaw",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))));

var SvgSteps = function SvgSteps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-1 -0.9999999999999956 23.999999999999993 32.04",
    width: 20,
    height: 28.04,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSteps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/steps.4a249fb7.svg";
export { ForwardRef as ReactComponent };